import { render } from "./TopicFolderDisplay.vue?vue&type=template&id=76e6848b&scoped=true"
import script from "./TopicFolderDisplay.vue?vue&type=script&lang=js"
export * from "./TopicFolderDisplay.vue?vue&type=script&lang=js"

import "./TopicFolderDisplay.vue?vue&type=style&index=0&id=76e6848b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e6848b"]])

export default __exports__